import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ApprochePage = lazy(() => import('../pages/approche/page'));
const AQuiSAdressePage = lazy(() => import('../pages/a-qui-sadresse/page'));
const PresencePage = lazy(() => import('../pages/presence/page'));
const ContenusMultimediaPage = lazy(() => import('../pages/contenus-multimedia/page'));
const FAQPage = lazy(() => import('../pages/faq/page'));
const PrendreRendezVousPage = lazy(() => import('../pages/prendre-rendez-vous/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/approche',
    element: <ApprochePage />,
  },
  {
    path: '/a-qui-sadresse',
    element: <AQuiSAdressePage />,
  },
  {
    path: '/presence',
    element: <PresencePage />,
  },
  {
    path: '/contenus-multimedia',
    element: <ContenusMultimediaPage />,
  },
  {
    path: '/faq',
    element: <FAQPage />,
  },
  {
    path: '/prendre-rendez-vous',
    element: <PrendreRendezVousPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
